import { css } from 'lit';
export default css `
    .outer-wrapper {
        height: 100%;
        overflow: visible;
    }

    .inner-wrapper {
        height: 100%;
        display: flex;
        flex-flow: column;
        justify-content: flex-end;
    }

    :host([form-factor='mobile']) {
        border-block-end: 1px solid var(--color-ui-06);
    }
`;
